// Same hues as the Overview tiles, so a metric reads the same in both places.
// The tiles use their hue as a filled card background; on the near-white chart
// surface the raw $color-chinese-yellow (#ffad00) is a 1.8:1 wash, so the bar
// takes a darker step of that same amber. Blue and red carry over unchanged.
export const AVERAGE_COLOR = '#3d53fa'; // $color-laser-blue
export const TOTAL_COLOR = '#e09600'; //   $color-chinese-yellow, darkened
export const COUNT_COLOR = '#ff3952'; //   $color-love-zone
export const SURFACE_COLOR = '#FAFAFA'; // $color-almost-white - panel behind the chart
export const GRID_COLOR = '#EEF0F4';

export const AVERAGE_LABEL = 'Average Time Per Card';
export const TOTAL_LABEL = 'Total Time Spent';
export const COUNT_LABEL = 'Number of Cards Time Tracked';

export const EMPTY_MESSAGE = 'There is no time tracked in this range.';

export const CHART_HEIGHT = 360;
export const MINUTE_MS = 60000;

// Stable identities, so the effect deps and default props don't change every render.
export const EMPTY_BUCKETS = [];
export const EMPTY_WORKSPACE_IDS = [];
export const EMPTY_ORGANIZATION_IDS = [];
